import { useLocalStorage } from "@src/appV2/lib/utils/useLocalstorage";

import { DELAYED_REVIEW_STORAGE_KEY } from "./constants";
import { type DelayedReviewInput, type DelayedReviewStoredData } from "./types";

interface UseDelayedReviewStorageReturn {
  setDelayedReview: (input: DelayedReviewInput) => void;
}

/**
 * Hook for saving a delayed workplace review to local storage.
 * Used by the timesheet submission page to save the review for later display.
 */
export function useDelayedReviewStorage(): UseDelayedReviewStorageReturn {
  const [, setDelayedReviewState] = useLocalStorage<DelayedReviewStoredData | null>(
    DELAYED_REVIEW_STORAGE_KEY,
    null
  );

  function setDelayedReview(input: DelayedReviewInput) {
    setDelayedReviewState({
      ...input,
      storedAt: new Date().toISOString(),
    });
  }

  return {
    setDelayedReview,
  };
}
